// The squares along one edge of the board, worked out from its bounds.
//
// It exists so a dev command can name an edge and the engine works out the
// row: the geometry lives here once, and whoever sends the command holds none.

import { type BoardEdge, fileOf, rankOf, square } from "./board";
import type { Position } from "./position";

/** The row or column of squares just outside this edge of the board's bounds. */
export function squaresBeyondEdge(position: Position, edge: BoardEdge): number[] {
  const { minFile, maxFile, minRank, maxRank } = position.bounds;
  const squares: number[] = [];
  if (edge === "north" || edge === "south") {
    const rank = edge === "north" ? maxRank + 1 : minRank - 1;
    for (let file = minFile; file <= maxFile; file++) squares.push(square(file, rank));
  } else {
    const file = edge === "east" ? maxFile + 1 : minFile - 1;
    for (let rank = minRank; rank <= maxRank; rank++) squares.push(square(file, rank));
  }
  return squares;
}

/** The ground squares on the outermost row or column of this edge. */
export function squaresOnEdge(position: Position, edge: BoardEdge): number[] {
  const { minFile, maxFile, minRank, maxRank } = position.bounds;
  const onEdge = (sq: number): boolean => {
    switch (edge) {
      case "north":
        return rankOf(sq) === maxRank;
      case "south":
        return rankOf(sq) === minRank;
      case "east":
        return fileOf(sq) === maxFile;
      case "west":
        return fileOf(sq) === minFile;
    }
  };
  return position.cellList.filter(onEdge);
}
